<template lang="pug">
div
	#sidebar.sidebar(:class="{ 'sidebar-transparent': pageOptions.pageSidebarTransparent }")
		vue-custom-scrollbar.height-full
			sidebar-nav-profile
			sidebar-nav(
				ref="sidebarNav"
				:scroll-top="scrollTop"
				@showFloatSubmenu="handleShowFloatSubmenu"
				@hideFloatSubmenu="handleHideFloatSubmenu"
			)
	.sidebar-bg
	.mobile-click(@click="dismissSidebar")
	.float-sub-menu-container(
		v-if="this.pageOptions.pageSidebarMinified"
		:class="{ 'd-none': !this.floatSubmenu }"
		:style="{ top: this.floatSubmenuTop, left: this.floatSubmenuLeft,	bottom: this.floatSubmenuBottom, right: this.floatSubmenuRight }"
		@mouseover="clearHideFloatSubmenu"
    @mouseleave="handleHideFloatSubmenu"
  )
		.float-sub-menu-arrow(:style="{ top: this.floatSubmenuArrowTop,	bottom: this.floatSubmenuArrowBottom }")
		.float-sub-menu-line(:style="{ top: this.floatSubmenuLineTop,	bottom: this.floatSubmenuLineBottom }")
		.float-sub-menu(v-if="floatSubmenuMenu")
			template(v-for="menu in this.floatSubmenuMenu")
				sidebar-nav-list(
          ref="sidebarNavList"
          :menu="menu"
          :key="menu.path"
          :status="menu.status"
          @calcFloatSubmenu="handleCalcFloatSubmenu"
        )
</template>

<script>
import SidebarNav from "./SidebarNav.vue";
import SidebarNavProfile from "./SidebarNavProfile.vue";
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "../../config/PageOptions.vue";

export default {
  name: "Sidebar",
  components: {
    SidebarNav,
    SidebarNavProfile,
    SidebarNavList
  },
  directives: {
    scroll: {
      inserted: function(el, binding) {
        let f = function(evt) {
          if (binding.value(evt, el)) {
            el.removeEventListener("scroll", f);
          }
        };
        el.addEventListener("scroll", f);

        if (typeof Storage !== "undefined") {
          if (localStorage.sidebarScroll) {
            el.scrollTop = localStorage.sidebarScroll;
          }
        }
      }
    }
  },
  data() {
    return {
      scrollTop: "",
      pageOptions: PageOptions,
      floatSubmenu: false,
      floatSubmenuMenu: "",
      floatSubmenuTop: "",
      floatSubmenuBottom: "",
      floatSubmenuLeft: "",
      floatSubmenuRight: "",
      floatSubmenuArrowTop: "",
      floatSubmenuArrowBottom: "",
      floatSubmenuLineTop: "",
      floatSubmenuLineBottom: "",
      clearSubmenu: "",
      subMenuOffset: ""
    };
  },
  methods: {
    handleCalcFloatSubmenu: function() {
      setTimeout(() => {
        var targetTop = this.subMenuOffset.top;
        var windowHeight = window.innerHeight;
        var targetHeight = document.querySelector(".float-sub-menu-container")
          .offsetHeight;

        if (windowHeight - targetTop > targetHeight) {
          this.floatSubmenuTop = this.subMenuOffset.top + "px";
          this.floatSubmenuBottom = "auto";
          this.floatSubmenuArrowTop = "20px";
          this.floatSubmenuArrowBottom = "auto";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = "auto";
        } else {
          this.floatSubmenuTop = "auto";
          this.floatSubmenuBottom = "0";

          var arrowBottom = windowHeight - targetTop - 21;
          this.floatSubmenuArrowTop = "auto";
          this.floatSubmenuArrowBottom = arrowBottom + "px";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = arrowBottom + "px";
        }
      }, 0);
    },
    handleShowFloatSubmenu: function(data, offset) {
      this.floatSubmenuMenu = data;
      this.floatSubmenu = true;
      this.subMenuOffset = offset;

      var targetTop = offset.top;
      var windowHeight = window.innerHeight;

      setTimeout(() => {
        var targetHeight = document.querySelector(".float-sub-menu-container")
          .offsetHeight;

        if (windowHeight - targetTop > targetHeight) {
          this.floatSubmenuTop = offset.top + "px";
          this.floatSubmenuBottom = "auto";
          this.floatSubmenuArrowTop = "20px";
          this.floatSubmenuArrowBottom = "auto";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = "auto";
        } else {
          this.floatSubmenuTop = "auto";
          this.floatSubmenuBottom = "0";

          var arrowBottom = windowHeight - targetTop - 21;
          this.floatSubmenuArrowTop = "auto";
          this.floatSubmenuArrowBottom = arrowBottom + "px";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = arrowBottom + "px";
        }
      }, 0);

      this.floatSubmenuRight = "auto";
      this.floatSubmenuLeft =
        document.getElementById("sidebar").offsetLeft + offset.width + "px";

      clearTimeout(this.clearSubmenu);
    },
    handleHideFloatSubmenu: function() {
      this.clearSubmenu = setTimeout(() => {
        this.floatSubmenu = false;
      }, 250);
    },
    clearHideFloatSubmenu: function() {
      clearTimeout(this.clearSubmenu);
    },
    handleScroll: function(evt) {
      this.scrollTop = evt.target.scrollTop;
      if (typeof Storage !== "undefined") {
        localStorage.setItem("sidebarScroll", this.scrollTop);
      }
    },
    dismissSidebar: function() {
      this.pageOptions.pageMobileSidebarToggled = false;
      this.pageOptions.pageMobileRightSidebarToggled = false;
    }
  }
};
</script>
